import { FC, useState } from "react";
import { AssortmentTaskType, TaskRoute, TaskStatus } from "tm-shared/types";

import { BaseModal } from "@/components/BaseModal";
import { COMMENT_OPTIONS } from "@/constants/ui/comment";
import { useAppDispatch } from "@/hooks/redux";
import {
    patchAssortmentFinGroupPhotosEntity,
    patchProductsMatrixEntity,
} from "@/store/slices/progress";
import {
    patchDMPEntity,
    patchPromoTagPhotosEntity,
} from "@/store/slices/progress";
import { ModalPayloads, ModalType } from "@/types/modals";

import { StyledSelect, StyledTextArea } from "./Styled";

interface CommentModalProps {
    onCloseModal: () => void;
    payload: ModalPayloads[ModalType.Comment];
}

export const CommentModal: FC<CommentModalProps> = ({
    onCloseModal,
    payload,
}) => {
    const dispatch = useAppDispatch();
    const { initialComment, route, taskStatus, taskId } = payload;
    const [localComment, setLocalComment] = useState(initialComment);

    const handleChange = (value: string) => {
        const currentOptionComment = COMMENT_OPTIONS.find(
            (option) => option.value === value,
        ) ?? { label: "" };

        setLocalComment(currentOptionComment.label);
    };

    const handleConfirm = () => {
        switch (route) {
            case TaskRoute.Dmp: {
                const { dmpId, contractId } = payload;
                dispatch(
                    patchDMPEntity({
                        taskId,
                        dmpId,
                        contractId,
                        patch: { comment: localComment },
                    }),
                );
                break;
            }
            case TaskRoute.PromoTagPhotos: {
                const { barcode } = payload;
                dispatch(
                    patchPromoTagPhotosEntity({
                        taskId,
                        barcode,
                        patch: { comment: localComment },
                    }),
                );
                break;
            }
            case AssortmentTaskType.FinGroupPhotos: {
                const { contractId, id, subtaskId } = payload;
                dispatch(
                    patchAssortmentFinGroupPhotosEntity({
                        taskId,
                        contractId,
                        subtaskId,
                        id,
                        patch: { comment: localComment },
                    }),
                );
                break;
            }

            case AssortmentTaskType.ProductsMatrix: {
                const { taskId, subtaskId, barcode, contractId } = payload;
                dispatch(
                    patchProductsMatrixEntity({
                        taskId,
                        contractId,
                        subtaskId,
                        barcode,
                        patch: { comment: localComment },
                    }),
                );
                break;
            }

            default:
                break;
        }

        onCloseModal();
    };

    return (
        <BaseModal
            open
            onClose={onCloseModal}
            title={"Залиште коментар"}
            confirmText="Зберегти"
            onConfirm={handleConfirm}
        >
            {taskStatus === TaskStatus.Rejected ? (
                <StyledSelect
                    onChange={handleChange}
                    placeholder="Залиште коментар"
                    options={COMMENT_OPTIONS}
                    defaultValue={COMMENT_OPTIONS.find(
                        (option) => option.label === initialComment,
                    )}
                />
            ) : (
                <StyledTextArea
                    autoSize={{ minRows: 5, maxRows: 10 }}
                    value={localComment}
                    placeholder="Ваш коментар..."
                    onChange={(event) => setLocalComment(event.target.value)}
                />
            )}
        </BaseModal>
    );
};
